import { History } from "lucide-react";
import { StatusBadge } from "./StatusBadge";
import { dayLabel, topicTitle, videoSrc } from "./socialMeta";

export const HistoryGrid = ({ posts, onSelect }) => (
  <section data-testid="social-history" className="bg-white border border-[#ECE7DE] rounded-2xl p-4 sm:p-5">
    <h3 className="flex items-center gap-2 text-sm font-bold text-[#1A1A1A] mb-3"><History className="w-4 h-4 text-[#F26419]" />Vidéos générées et publiées</h3>
    {posts.length === 0
      ? <p data-testid="social-history-empty" className="text-sm text-[#75807A]">Les vidéos des jours passés apparaîtront ici.</p>
      : <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {posts.map((p) => (
            <button key={p.id} data-testid={`social-history-${p.date}`} onClick={() => onSelect(p)} className="text-left group">
              <div className="aspect-[9/16] rounded-xl overflow-hidden bg-[#F2EEE7]">
                {p.video_url && <video src={`${videoSrc(p.video_url)}#t=1`} preload="metadata" muted className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-300" />}
              </div>
              <div className="mt-1.5 text-[11px] font-bold uppercase text-[#75807A]">{dayLabel(p.date)}</div>
              <div className="text-xs font-semibold text-[#1A1A1A] line-clamp-1">{topicTitle(p.topic)}</div>
              <div className="mt-1"><StatusBadge status={p.status} /></div>
            </button>
          ))}
        </div>}
  </section>
);
